import * as PropTypes from "prop-types";
import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import {ff, form} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
const {Form, FormBody, FormActions} = form;
import CustomCheckboxField from "../components/CustomCheckboxField";
import ObjectSelect from "../components/ObjectSelect";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Formulář pro úpravu údajů provozovatele.
 */
class ProvozovatelForm extends Component<WithTranslation> {

    static formName = 'ProvozovatelForm';

    static propTypes = {
        zpusobyDopravyList: PropTypes.array.isRequired,
        zpusobyPlatbyList: PropTypes.array.isRequired,
    };

    render() {
        const {onClose, submitting, handleSubmit, zpusobyDopravyList, zpusobyPlatbyList, t} = this.props;
        return <Form onSubmit={handleSubmit} horizontal>
            <FormBody>
                <ff.String label={t('operator_name')} name="nazevFirma" disabled={submitting}/>
                <ff.String label={t('cin')} name="ic" disabled={submitting}/>
                <ff.String label={t('vatin')} name="dic" disabled={submitting}/>
                <ff.String label={t('street')} name="ulice" disabled={submitting}/>
                <ff.Number label={t('zip')} name="psc" disabled={submitting}/>
                <ff.String label={t('city')} name="obec" disabled={submitting}/>
                <ff.String label={t('phone')} name="telefon" disabled={submitting}/>
                <ff.String label={t('email')} name="email" disabled={submitting}/>
                <ff.String label={t('web_page')} name="www" disabled={submitting}/>
                <CustomCheckboxField label={t('order_without_comp')} name="zakazkaBezSpol" disabled={submitting}/>
                <ff.Time label={t('show_time_from')} name="zobrazovatCasOd" disabled={submitting}/>
                <ff.Time label={t('show_time_to')} name="zobrazovatCasDo" disabled={submitting}/>
                <ff.Number label={t('time_between_choosing_min')} name="krokCasMinut" disabled={submitting}/>
                <ff.String label={t('log_path')} name="cestaLogo" disabled={submitting}/>
                <ff.String label={t('order.order_number_series')} name="ciselnaRadaObj" disabled={submitting}/>
                <ff.String label={t('order_heel')} name="patickaZakazka" disabled={submitting}/>
                <ObjectSelect
                    label={t('order.default_delivery_method')}
                    name="zpusobDopravaVychozi"
                    items={zpusobyDopravyList}
                    getItemValue={(item) => item ? item.nazevDoprava : ""}
                    disabled={submitting}
                    showEmpty={true}
                />
                <ObjectSelect
                    label={t('order.default_payment_method')}
                    name="zpusobPlatbaVychozi"
                    items={zpusobyPlatbyList}
                    getItemValue={(item) => item ? item.nazevZpusobPlatba : ""}
                    disabled={submitting}
                    showEmpty={true}
                />
                <CustomCheckboxField label={t('allow_price_offer')} name="cenovaNabidka" disabled={submitting}/>
                <CustomCheckboxField label={t('register_delivery')} name="evidovatDopravu" disabled={submitting}/>
            </FormBody>
            <FormActions onClose={onClose} storeButton={t('save')} cancelButton={t('buttons.cancel')} disabled={submitting}/>
        </Form>
    }

}

export default withTranslation()(connect()(reduxForm({
    form: ProvozovatelForm.formName,
})(ProvozovatelForm)));
